
/**
 *
 * @param str 要处理的字符串
 * @param number 每一项要显示多少个文字
 */
export const tooltipLthFn = (str: string, number = 40): string[] => {
  let idx = 0
  let flag = true
  let deviation = 0
  const sketchList: string[] = []
  while (flag) {
    const _str = str.substring(deviation, deviation + number)
    sketchList.push(_str)
    if (_str.length < number) {
      flag = false
    }
    idx++
    deviation = idx * number
  }
  return sketchList
}
